import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateDosespotClinicianRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchUpdateDosespotClinician } from '../api/updateDosespotClinician.js';
import { dosespotClinicianKeys } from './keys.js';

export interface UpdateDosespotClinicianVariables {
  userId: string;
  data: UpdateDosespotClinicianRequestT;
}

export function useUpdateDosespotClinicianMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['dosespot-clinician', 'update'],
    mutationFn: async ({ userId, data }: UpdateDosespotClinicianVariables) => {
      return await fetchUpdateDosespotClinician(userId, data);
    },
    onSuccess: () => {
      // Invalidate my clinician info after update
      queryClient.invalidateQueries({ queryKey: dosespotClinicianKeys.myInfo() });
    },
  });
}
